import { Button, CircularProgress } from "@material-ui/core";

const ActionButton = ({
  classes,
  onClose,
  updateTerminalInfo,
  updateInProgress,
  buttonText,
}) => {
  return (
    <div className={classes.footer}>
      <Button
        color="primary"
        variant="outlined"
        className={classes.cancelButton}
        onClick={onClose}
      >
        Cancel
      </Button>
      <Button
        color="primary"
        variant="contained"
        classes={{
          root: classes.updateButton,
          disabled: classes.disabledButton,
        }}
        onClick={updateTerminalInfo}
      >
        {updateInProgress ? (
          <CircularProgress
            size={16}
            classes={{ root: classes.circularProgress }}
          />
        ) : (
          buttonText
        )}
      </Button>
    </div>
  );
};

export default ActionButton;
